import { createTypesenseClient } from "@buildwithflux/search";
import { useEffect, useState } from "react";
import type { Client } from "typesense";

import { getAccountsApiBase } from "../utils/apiBase";
import { fetchWithRetry } from "../utils/fetchWithRetry";

const TYPESENSE_HOST = "8iq4spr5t63o1vlgp.a1.typesense.net";

interface TypesenseAuthResponse {
    scopedSearchKey: string;
}

async function fetchScopedKey(): Promise<string> {
    const res = await fetchWithRetry(() =>
        fetch(`${getAccountsApiBase()}/accounts/auth/typesense`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
        }),
    );
    if (!res.ok) {
        throw new Error(`Typesense auth failed: ${res.status}`);
    }
    const data = (await res.json()) as TypesenseAuthResponse;
    return data.scopedSearchKey;
}

/** Pass `enabled: false` on surfaces that never search these collections. */
export function useTypesenseClient(enabled = true): Client | null {
    const [client, setClient] = useState<Client | null>(null);

    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;

        fetchScopedKey()
            .then((key) => {
                if (cancelled) return;
                setClient(
                    createTypesenseClient({
                        host: TYPESENSE_HOST,
                        port: 443,
                        protocol: "https",
                        apiKey: key,
                        cacheSearchResultsForSeconds: 10,
                    }),
                );
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.error("Failed to initialize Typesense client:", err);
            });

        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return client;
}
